import { useState } from "react";
import PacmanLoader from "react-spinners/SyncLoader";

export const SpinnerComponent = ({ loading, components }) => {
  return (
    <div className="content">
      <div className="spinner">
        <PacmanLoader
          color={"#FFED29"}
          loading={loading}
          size={15}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
      {components}
    </div>
  );
};
